module.exports = __webpack_public_path__ + "static/media/create_summary.dc6a3580.png";


//////////////////
// WEBPACK FOOTER
// ./src/img/create_summary.png
// module id = 782
// module chunks = 0